export type CursorDefinition = {
  path: string;
  path2x: string;
  size: { width: number; height: number; renderWidth?: number; renderHeight?: number };
  hotSpot?: { x: number; y: number };
};

export enum CursorEnum {
  DEFAULT = 'default',
  POINTER = 'pointer',
  CROSSHAIR = 'crosshair',
  MOVE = 'move',
  GRABBING = 'grabbing',
  RESIZE_HORIZONTAL = 'resize-ew',
  ALL_SCROLL = 'all-scroll',
  NOT_ALLOWED = 'not-allowed',
  WALL_SPLIT = 'wall-split',
  WALL_JOIN = 'wall-join',
  MULTI_SELECT = 'multi-select',
  ARRAY_MATRIX = 'array-matrix',
  ARRAY_LINE = 'array-line',
  MEASURE = 'measure',
  DRAW_AREA_DIMENSION = 'drawAreaDimension',
  DRAW_LINEAR_DIMENSION = 'drawLinearDimension'
}
